import { render, staticRenderFns } from "./helpManage.vue?vue&type=template&id=49ef85bf&scoped=true"
import script from "./helpManage.vue?vue&type=script&lang=js"
export * from "./helpManage.vue?vue&type=script&lang=js"
import style0 from "./helpManage.vue?vue&type=style&index=0&id=49ef85bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef85bf",
  null
  
)

export default component.exports